$bog_prof_app $mol_book2_catalog
	Placeholder null
	Menu_logo $mol_image
		uri \bog/prof/assets/job.png
	menu_title @ \VibeJobs 
	menu_tools /
		<= Lights $mol_lights_toggle
	plugins /
		<= Theme $bog_prof_theme_auto
	spreads *
		\	
			<= Bot $gd_bot
				Space null
				Sources null
				Donate null
				Support null
				Lights null
		prof <= Prof $bog_prof_app_prof
		settings <= Settings $bog_prof_app_settings
		vaka <= Vaka $bog_prof_app_vaka
